import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $id: String!
    $data: CultureUpdateInput!
  ) {
    updateOneCulture(
      where: { id: $id }
      data: $data
    ) {
      name
    }
  }
`

export default () => (
  useMutation(MUTATION, `Cultura actualizada`, mutationTypes.UPDATE)
)
